import { useSite } from '../../app/site';
import { cn } from '../../lib/cn';

/**
 * One site mark: the shipped Medaka M SVG at `/favicon.svg` (header + tab icon).
 * A custom upload in 网站设置 replaces this path. Boot splash uses the same src.
 */
export const DEFAULT_SITE_ICON = '/favicon.svg';
export const SITE_LOGO_CACHE_KEY = 'mgr.siteLogo';

export function siteIconSrc(settings?: { logoUrl?: string | null; faviconUrl?: string | null } | null) {
  return settings?.logoUrl || settings?.faviconUrl || DEFAULT_SITE_ICON;
}

export function cacheSiteIcon(url: string) {
  try {
    localStorage.setItem(SITE_LOGO_CACHE_KEY, url);
  } catch {
    /* Private mode / quota. */
  }
}

export function LogoMark({ className }: { className?: string }) {
  const { settings } = useSite();
  const src = siteIconSrc(settings);
  return <img src={src} alt="" className={cn('size-8 rounded-sm object-contain', className)} />;
}

export function Logo({ siteName, className }: { siteName: string; className?: string }) {
  return (
    <span className={cn('flex items-center gap-2.5', className)}>
      <LogoMark />
      <span className="hidden flex-col leading-none sm:flex">
        <span className="font-display text-sm font-semibold tracking-tight">{siteName}</span>
        <span className="text-2xs text-text-faint mt-0.5 tracking-[0.18em] uppercase">Reward</span>
      </span>
    </span>
  );
}
